import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { FiCheck, FiAlertTriangle, FiArrowRight, FiLoader } from 'react-icons/fi'

// Página landing del clic de confirmación del email de newsletter.
// Recoge el token de la query string, llama al endpoint y muestra el resultado.
export default function NewsletterConfirmar() {
  const [params] = useSearchParams()
  const token = params.get('token')
  const [estado, setEstado] = useState(token ? 'cargando' : 'sin_token')
  const [yaConfirmado, setYaConfirmado] = useState(false)

  useEffect(() => {
    if (!token) return
    let cancelado = false
    fetch(`/api/blog/newsletter/confirm?token=${encodeURIComponent(token)}`)
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (cancelado) return
        if (ok) {
          setYaConfirmado(Boolean(data.ya_confirmado))
          setEstado('ok')
        } else {
          setEstado('error')
        }
      })
      .catch(() => { if (!cancelado) setEstado('error') })
    return () => { cancelado = true }
  }, [token])

  return (
    <>
      <Helmet>
        <title>Confirmar suscripción | PresenzIA</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="min-h-screen bg-white flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <Link to="/landing" className="inline-flex items-center gap-2 mb-8">
            <img src="/logo-presenzia-icon.svg" alt="PresenzIA" className="w-8 h-8 rounded-lg" />
            <span className="text-lg font-bold text-gray-900">Presenz<span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-cyan-500">IA</span></span>
          </Link>

          {estado === 'cargando' && (
            <div className="py-8">
              <FiLoader className="h-8 w-8 mx-auto animate-spin text-blue-600" />
              <p className="mt-4 text-sm text-gray-500">Confirmando tu suscripción…</p>
            </div>
          )}

          {estado === 'ok' && (
            <div className="py-8">
              <div className="w-16 h-16 mx-auto rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mb-5">
                <FiCheck className="h-8 w-8" />
              </div>
              <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-3">
                {yaConfirmado ? 'Ya estabas suscrito' : '¡Suscripción confirmada!'}
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed">
                {yaConfirmado
                  ? 'Tu email ya estaba en nuestra lista. Seguirás recibiendo nuestros artículos.'
                  : 'A partir de ahora recibirás nuestras guías sobre control horario, normativa laboral y gestión de equipos.'}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Link to="/blog" className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-5 py-2.5 rounded-xl text-sm">
                  Volver al blog <FiArrowRight className="h-4 w-4" />
                </Link>
                <Link to="/registro" className="inline-flex items-center justify-center gap-2 border border-gray-200 text-gray-700 hover:border-gray-300 font-semibold px-5 py-2.5 rounded-xl text-sm">
                  Probar PresenzIA gratis
                </Link>
              </div>
            </div>
          )}

          {(estado === 'error' || estado === 'sin_token') && (
            <div className="py-8">
              <div className="w-16 h-16 mx-auto rounded-full bg-amber-100 text-amber-600 flex items-center justify-center mb-5">
                <FiAlertTriangle className="h-8 w-8" />
              </div>
              <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-3">No se ha podido confirmar</h1>
              <p className="text-gray-600 mb-8 leading-relaxed">
                El enlace no es válido o ya se ha usado. Si crees que es un error, vuelve a suscribirte desde cualquier artículo del blog.
              </p>
              <Link to="/blog" className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-5 py-2.5 rounded-xl text-sm">
                Ir al blog <FiArrowRight className="h-4 w-4" />
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
